import { ReactNode } from "react";
import { Typography } from "../ui/Typography/Typography";
import "./ActionPlanTrainingWizard.scss";

interface WizardStepLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}
export const WizardStepLayout = ({
  title,
  description,
  children,
}: WizardStepLayoutProps) => {
  return (
    <div className="WizardStepLayout">
      <div className="WizardStepLayout__header">
        <Typography desktop="h2" weight="bold">
          {title}
        </Typography>
        <Typography desktop="body1" color="secondary">
          {description}
        </Typography>
      </div>
      <div className="WizardStepLayout__content">{children}</div>
    </div>
  );
};
